import React from "react";
import "./drawer.style.sass";
import { ButtonToolbar, Button, Drawer, Icon, Nav } from "rsuite";
import { connect } from "react-redux";
import SiteTypes from "../../redux/site/site.types";
import { ChangeActiveLink } from "../../redux/site/site.actions";
import LinkData from "../../data/navBar/links.data.json";
import {
	selectActiveLink,
	selectShowMenu,
} from "../../redux/site/site.selector";
import { createStructuredSelector } from "reselect";
import { withRouter } from "react-router-dom";
import axios from "axios";
import { Setting } from "../../setting";

class DrawerNav extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			apiRes: "https://newgps.xitonix.com/",
			showPayment: 0,
		};
	}

	componentDidMount() {
		axios.get(`${Setting.apiUrl}api/setting/list`).then((res) => {
			this.setState({
				apiRes: res.data.track_plan_address,
				showPayment: res.data.show_online_payment,
			});
		});
	}

	render() {
		const { toggle, closeDis, Active, changeActive, history } = this.props;
		const { apiRes } = this.state;
		return (
			<div className="drawer-nav">
				<ButtonToolbar className="drawer-button">
					<Button
						className="drawer-btn"
						onClick={closeDis}
					>
						<Icon icon={"bars"} />
					</Button>
				</ButtonToolbar>
				<Drawer
					placement="right"
					size="xs"
					show={toggle}
					onHide={closeDis}
					className="drawer-container"
					enforceFocus
					keyboard
				>
					<Drawer.Header>
						<Drawer.Title className="drawer-title">منو</Drawer.Title>
					</Drawer.Header>
					<Drawer.Body className="Drawer-Nav">
						<Nav
							appearance="subtle"
							vertical
							activeKey={Active}
							onSelect={(activeKey) => changeActive(activeKey)}
							style={{ width: "100%" }}
						>
							{LinkData.map((item, i) => {
								return item.id !== "14" ? (
									<Nav.Item
										key={item.id}
										eventKey={item.activeKey}
										icon={<Icon icon={item.icon} />}
										onClick={() => {
											if (item.activeKey === "tracking") {
												window.location.href =
													item.id === "2" ? apiRes : item.link;
											} else if (item.activeKey === "home") {
												changeActive(item.activeKey);
												history.push("/");
											} else {
												changeActive(item.activeKey);
												history.push(`/${item.activeKey}`);
											}
											setTimeout(closeDis, 50);
										}}
										style={{ animationDelay: `${i * 180}ms` }}
									>
										{item.text}
									</Nav.Item>
								) : (
									this.state.showPayment !== "0" && (
										<Nav.Item
											key={item.id}
											eventKey={item.activeKey}
											icon={<Icon icon={item.icon} />}
											onClick={() => {
												if (item.activeKey === "tracking") {
													window.location.href =
														item.id === "2" ? apiRes : item.link;
												} else if (item.activeKey === "home") {
													changeActive(item.activeKey);
													history.push("/");
												} else {
													changeActive(item.activeKey);
													history.push(`/${item.activeKey}`);
												}
												setTimeout(closeDis, 50);
											}}
											style={{ animationDelay: `${i * 180}ms` }}
										>
											{item.text}
										</Nav.Item>
									)
								);
							})}
						</Nav>
					</Drawer.Body>
					<Drawer.Footer>
						<Button
							className="btn-close"
							onClick={closeDis}
							appearance="subtle"
						>
							بستن
						</Button>
					</Drawer.Footer>
				</Drawer>
			</div>
		);
	}
}

const mapStateToProps = createStructuredSelector({
	toggle: selectShowMenu,
	Active: selectActiveLink,
});
const mapDispatchToProps = (dispatch) => ({
	closeDis: () => dispatch({ type: SiteTypes.TOGGLE_MENU }),
	changeActive: (activeKey) => dispatch(ChangeActiveLink(activeKey)),
});

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(DrawerNav)
);
